import React from 'react'

export default function FAQs() {
  const faqs = [
    {
      question: 'What is the demo presentation format?',
      answer: 'Each company gets 7 minutes for their demo presentation followed by 3 minutes of Q&A. Presentations should focus on your product\'s unique value proposition and market impact.'
    },
    {
      question: 'How many team members can attend?',
      answer: 'Each demo company receives 4 networking passes (2 Gold and 2 Silver). Gold passes include access to all sessions and networking events, while Silver passes cover the main event and demo sessions.'
    },
    {
      question: 'What are the technical requirements?',
      answer: 'The venue provides a projector, microphone, and standard AV setup. If you need specific technical requirements (live demos, internet connectivity, etc.), please specify during registration.'
    },
    // {
    //   question: 'When is the deadline for submissions?',
    //   answer: 'All presentation materials and company details must be submitted by October 4, 2025. Late submissions may not be accepted due to event logistics.'
    // },
    {
      question: 'What must our deck cover to align with judging?',
      answer: 'Cover business impact, scalability, traction, solution uniqueness, roadmap, founder recognition, and clarity of delivery.'
    },
    {
      question: 'Which sections are most often missed?',
      answer: 'Common gaps: problem and solution, founder experience, and future roadmap. Surface these early in the deck.'
    },
    {
      question: 'Can we include confidential information?',
      answer: 'Avoid confidential details in decks or Q&A; keep data high-level.'
    },
    // {
    //   question: 'How do we earn networking passes?',
    //   answer: 'Complete all networking tasks: create profile, connect with 15+ people, schedule 5+ meetings, and engage actively.'
    // },
    // {
    //   question: 'What support is available during preparation?',
    //   answer: 'Contact Maulika for demo questions or Riny for sponsorship queries. CEO feedback sessions are also available.'
    // },
    // {
    //   question: 'How can I request more Silver Passes?',
    //   answer: 'Use the "Request more Silver Passes" button in the Event Day task. This allows you to get additional passes for investors, clients, colleagues, and other stakeholders you\'d like to invite to the event.'
    // },
    {
      question: 'What benefits do demo companies receive?',
      answer: 'Demo companies get access to Fintech Olympiad, exclusive job posting opportunities, and personalized promotional materials.'
    },
    // {
    //   question: 'How long are the benefits available?',
    //   answer: 'Benefits are available for one year after the event, with Fintech Olympiad lasting until March 2026.'
    // },
    // {
    //   question: 'Are there any additional costs for the benefits?',
    //   answer: 'All benefits are complimentary for demo participants. No additional costs or fees apply.'
    // },
    {
      question: 'Can I share sales contact information during my presentation?',
      answer: 'No, presentations should not include sales contact information or pricing discussions. Focus on your product innovation, technology, and business impact. Your company website can be displayed, but avoid sales-focused content. The demo is about showcasing your solution\'s merit, not making sales pitches.'
    },
    {
      question: 'How do I pre-record my product demo video?',
      answer: 'For laptop screens: Use Zoom or Loom to record your screen with sample data (not real customer data). Edit out delays and mistakes for a clean ~3 minute video. For mobile apps: Use QuickTime for iPhone or Vysor for Android to mirror your screen. For audio quality: Use krisp.ai with Zoom to remove background noise. Final format: HD quality (1920x1080), 16:9 aspect ratio, MP4 format. You can either record narration or present live over a silent video.'
    }
  ]

  return (
    <div className="min-h-screen bg-white py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-10">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Frequently Asked Questions
          </h1>
          <p className="text-gray-600">
            Find answers to common questions about IFTA Demo and Awards 2025
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-green-50/40 border border-green-100 rounded-xl p-6 hover:shadow-sm transition-shadow"
            >
              <h3 className="text-lg font-semibold text-gray-900 mb-3">
                {faq.question}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>

        {/* Contact Section */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">
            Still have questions?
          </h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="font-medium text-gray-900 mb-2">Demo Questions</h3>
              <p className="text-sm text-gray-600 mb-1">
                For questions about presentation format, technical requirements, and demo logistics
              </p>
              <a href="mailto:maulika@indiafintech.com" className="text-blue-600 hover:underline text-sm">
                maulika@indiafintech.com
              </a>
            </div>
            <div>
              <h3 className="font-medium text-gray-900 mb-2">Sponsorship & Partnerships</h3>
              <p className="text-sm text-gray-600 mb-1">
                For sponsorship opportunities and strategic partnerships
              </p>
              <a href="mailto:riny@indiafintech.com" className="text-blue-600 hover:underline text-sm">
                riny@indiafintech.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}